// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lesson-container {
  background-color: #fff;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 50rem;
  margin: 0 auto;
  border: 0.2rem solid; /* 必須 */
  border-image: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8) 1; /* グラデーションボーダー */
  border-radius: 0.75rem;
}

.lesson-title {
  font-size: 1.8rem;
  font-family: serif;
  font-weight: bold;
  color: #2a3d86;
  margin-bottom: 1rem;
}

.lesson-date {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 1.5rem;
}

.lesson-button {
  display: inline-block;
  background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.75rem 2rem;
  border-radius: 2rem;
  text-decoration: none;
  transition: background 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.lesson-button:hover {
  background: linear-gradient(90deg, #1f2b64, #3b4b95, #6a8fbe);
}

.lesson-container:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

`, "",{"version":3,"sources":["webpack://./src/styles/DavidGroupLessonButton.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,oBAAoB,EAAE,OAAO;EAC7B,iEAAiE,EAAE,gBAAgB;EACnF,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".lesson-container {\n  background-color: #fff;\n  padding: 2rem;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 50rem;\n  margin: 0 auto;\n  border: 0.2rem solid; /* 必須 */\n  border-image: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8) 1; /* グラデーションボーダー */\n  border-radius: 0.75rem;\n}\n\n.lesson-title {\n  font-size: 1.8rem;\n  font-family: serif;\n  font-weight: bold;\n  color: #2a3d86;\n  margin-bottom: 1rem;\n}\n\n.lesson-date {\n  font-size: 1.2rem;\n  color: #333;\n  margin-bottom: 1.5rem;\n}\n\n.lesson-button {\n  display: inline-block;\n  background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 0.75rem 2rem;\n  border-radius: 2rem;\n  text-decoration: none;\n  transition: background 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.lesson-button:hover {\n  background: linear-gradient(90deg, #1f2b64, #3b4b95, #6a8fbe);\n}\n\n.lesson-container:hover {\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
